<script setup lang="ts">
/**
 * Modale Chat : ouvre la vue Chat en overlay (overlays.store) au lieu d'une
 * navigation pleine page. La route /chat reste un deep-link.
 */
import { computed } from 'vue';
import { useOverlaysStore } from '@/stores/overlays.store';
import ChatView from '@/views/game/ChatView.vue';

const overlays = useOverlaysStore();
const open = computed({
  get: () => overlays.chatOpen,
  set: (v: boolean) => { overlays.chatOpen = v; },
});
</script>

<template>
  <el-dialog
    v-model="open"
    title="💬 Chat"
    width="min(94vw, 1100px)"
    append-to-body
    destroy-on-close
    align-center
    class="overlay-dialog"
  >
    <ChatView v-if="open" />
  </el-dialog>
</template>

<style scoped lang="scss">
.overlay-dialog :deep(.el-dialog__body) {
  max-height: 80vh;
  overflow-y: auto;
  padding-top: 0;
}
</style>
